"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newJFDField = void 0;
const uuid_1 = require("uuid");
function newJFDField(fieldDef) {
    const jfdField = {
        ...fieldDef,
        id: uuid_1.v4(),
        value: fieldDef.defaultValue || '',
        error: '',
        isDirty: false,
        /**
         * Take info from the JFD and generate a data structure that can be used to
         * populate the fields defined in this JFL implementation
         */
        fillInMockData() {
            const mockedData = jfdField.getMockData();
            // Skip filling-in data if it's empty
            if (mockedData)
                this.value = mockedData;
        },
        validate() {
            if (this.value.length === 0) {
                if (this.required) {
                    return 'Field is required';
                }
                else {
                    return '';
                }
            }
            if (this.minLength && this.value.length < this.minLength) {
                return `Min length of ${this.minLength} is not met`;
            }
            if (this.maxLength && this.value.length > this.maxLength) {
                return `Max length of ${this.maxLength} has exceeded`;
            }
            if (this.regex) {
                const regex = RegExp(this.regex);
                const realValue = this.convertToUpperCase ? this.value.toUpperCase() : this.value;
                if (!regex.test(realValue)) {
                    return `Failed to meet the matching criteria`;
                }
            }
            return '';
        }
    };
    return new Proxy(jfdField, isDirtyHandler);
}
exports.newJFDField = newJFDField;
const isDirtyHandler = {
    set(target, key, value) {
        // set isDirty directly
        if (key === 'isDirty') {
            target[key] = value;
            return true;
        }
        // mark this field as dirty when _any_ property changes
        // we use this in JFDFormField in the React app to skip unnecessary renders
        const oldVal = Reflect.get(target, key);
        if (oldVal !== value) {
            Reflect.set(target, key, value);
            target.isDirty = true;
        }
        return true;
    }
};
//# sourceMappingURL=jfd-fields.js.map